import { render } from "./billDetail.vue?vue&type=template&id=561aae94&scoped=true"
import script from "./billDetail.vue?vue&type=script&lang=js"
export * from "./billDetail.vue?vue&type=script&lang=js"

import "./billDetail.vue?vue&type=style&index=0&id=561aae94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561aae94"]])

export default __exports__